import { render, staticRenderFns } from "./TextResult.vue?vue&type=template&id=2f90941a&scoped=true&"
import script from "./TextResult.vue?vue&type=script&lang=js&"
export * from "./TextResult.vue?vue&type=script&lang=js&"
import style0 from "./TextResult.vue?vue&type=style&index=0&id=2f90941a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90941a",
  null
  
)

export default component.exports